<template>
  <div :class="['backTopBox',flag ? 'opacity1' : 'opacity0']" @click="handleBackToTheTop">
    <el-image :src="upIcon" class="upIcon"></el-image>
    <el-image :src="backIcon" class="backIcon"></el-image>
  </div>
</template>

<script setup>
import {defineEmits, defineProps, onMounted, ref} from "vue";
import {AdaptationScreen} from "@/common/js/config.default";

const props = defineProps({
  scrollbarRef: {
    type: Object,
    default: null
  }
})

const emit = defineEmits(['handleBackToTheTop'])

const upIcon = require('@/assets/components/backTop/up.png')
const backIcon = require('@/assets/components/backTop/back.png')

const screenType = ref('pc');

const flag = ref(false);

const openMask = () => {
  flag.value = true;
}

const closeMask = () => {
  flag.value = false;
}

const handleBackToTheTop = () => {
  emit('handleBackToTheTop', true);
}
defineExpose({
  openMask,
  closeMask
})

onMounted(() => {
  AdaptationScreen(() => {
    //console.log("手机")
    screenType.value = 'mobile'
  }, () => {
    //console.log("PC")
    screenType.value = 'pc'
  },);
})


</script>

<style scoped lang="scss">
@import "@/common/scss/breakpoints";
.backTopBox {
  width: 98px;
  height: 98px;
  position: fixed;
  bottom: 100px;
  right: 20px;

  .upIcon {
    width: 98px;
    height: 98px;
    cursor: pointer;

    &:hover + .backIcon {
      transition: all 0.3s;
      opacity: 1;
    }
  }

  .backIcon {
    width: 146px;
    height: 67px;
    position: absolute;
    top: 50%;
    left: -146px;
    transform: translateY(-50%);
    opacity: 0;
  }
}

@include media-breakpoint-up("md") {
  @import "./index-md.scss";
}
</style>
